export default "__VITE_ASSET__g3sc8m6G__"